import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import KogInputAutoCompleteCheckControlled from "@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled";
import { isNullUndefined } from "@/main/services/utils";

import { GeneralVariableType, useDynamicFiltersExport } from "./dynamicFiltersExport";
import { getQuoteStatus, useQuoteStatusReducer } from "@/main/store/quoteStatus";

interface IVariableTypeOrderStatusProps extends GeneralVariableType {}
function VariableTypeOrderStatus({ filter }: IVariableTypeOrderStatusProps) {
	const dispatch = useDispatch();
	const { findFieldIndexByGuidDynamicReportVariable, idScreen } = useDynamicFiltersExport();
	const { quoteStatus: quoteStatusReducer } = useQuoteStatusReducer();
	const { control } = useFormContext();

	useEffect(() => {
		dispatch(getQuoteStatus());
	}, []);

	const disabledStatus = isNullUndefined(quoteStatusReducer.data) || quoteStatusReducer.data.length === 1;
	const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

	return (
		<>
			<KogInputAutoCompleteCheckControlled
				name={`filtersDinamics.${indexField}.value`}
				disableSelectAll
				control={control}
				options={quoteStatusReducer.data || []}
				label={filter.responseServer.filterName}
				disabled={disabledStatus}
				isLoading={quoteStatusReducer.isLoading}
				controllerProps={{
					rules: { required: filter.responseServer.mandatory },
				}}
				customInputProps={{
					required: filter.responseServer.mandatory,
					id: idScreen("select-status"),
				}}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default VariableTypeOrderStatus;
